import { IconProps } from '../Icons.type'

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1.5L5 5.5L9 1.5"
        stroke="currentColor"
        strokeOpacity="0.6"
        strokeWidth="1.43"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
